<script setup lang="ts">
import { ref, toRef } from "vue";

defineOptions({
    inheritAttrs: false,
});
const model = defineModel();
const props = defineProps({
    type: {
        type: String,
        default: "text",
        required: false,
    },
    name: {
        type: String,
        required: true,
    },

    error: {
        type: String,
        default: null,
    },
    showPassword: {
        type: Boolean,
        default: true,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    placeholder: {
        type: String,
        default: "",
    },
    maxLength: {
        type: Number,
        default: null,
    },
});

const emit = defineEmits(["update:modelValue"]);

const name = toRef(props, "name");

const passwordVisible = ref(false);

const togglePasswordVisibility = () => {
    passwordVisible.value = !passwordVisible.value;
};
</script>

<template>
    <div class="input-group input-group-password">
        <input
            :name="name"
            :id="name"
            class="form-control rounded"
            :type="passwordVisible ? 'text' : 'password'"
            :class="{ 'is-invalid': !!error }"
            :disabled="disabled"
            :placeholder="placeholder"
            v-model="model"
        />
        <button
            type="button"
            class="btn"
            @click="togglePasswordVisibility"
            v-if="showPassword"
        >
            <i :class="passwordVisible ? 'bi bi-eye-slash-fill' : 'bi-eye-fill'"></i>
        </button>
        <span
            class="invalid-feedback"
            role="alert"
            v-if="error"
        >
            {{ error }}
        </span>
    </div>
</template>
